import { postRelationship, deleteRelationship } from './relationships-queries';

const UPDATE_CRQ_RELATIONSHIPS_REQUEST = 'UPDATE_CRQ_RELATIONSHIPS_REQUEST';
const UPDATE_CRQ_RELATIONSHIPS_SUCCESS = 'UPDATE_CRQ_RELATIONSHIPS_SUCCESS';
const UPDATE_CRQ_RELATIONSHIPS_ERROR = 'UPDATE_CRQ_RELATIONSHIPS_ERROR';



const updateCrqRelationshipsRequest = (crqId) => ({
  type: UPDATE_CRQ_RELATIONSHIPS_REQUEST,
  payload: {
    crqId,
  },
});

const updateCrqRelationshipsSuccess = (crqId) => ({
  type: UPDATE_CRQ_RELATIONSHIPS_SUCCESS,
  payload: {
    crqId,
  },
});

const updateCrqRelationshipsError = (crqId, error) => ({
  type: UPDATE_CRQ_RELATIONSHIPS_ERROR,
  payload: {
    crqId,
    error,
  },
});




const updateCrqRelationships = ({
  crqId,
  unsavedRelationships,
  formFlow,
}) => (dispatch, getState) => {
  dispatch(updateCrqRelationshipsRequest(crqId));
  // unsaved relationships can either be for deletion or update
  // collect the promises for each one
  const promises = unsavedRelationships.map(({
    relationshipId,
    sectionId,
    relationship,
    toDelete,
  }) => {
    // if this id is marked as deletion, return the deletRelationship query promise.
    if (toDelete) {
      return deleteRelationship(relationshipId, crqId);
    }
    // this relationship is for update.
    return postRelationship(relationship, crqId);
  });
  return Promise.all(promises)
    .then(() => {
      dispatch(updateCrqRelationshipsSuccess(crqId));
    }).catch((error) => {
      console.error(error);
      dispatch(updateCrqRelationshipsError(crqId, error));
      return Promise.reject(error);
    });
};

// get param for VINE relationship
const updateVINERelationship = (
  crqId,
  relationship,
) => {
  const unsavedRelationships = [];
  const vineParam = {
    relationship: {
      crqId,
      name: relationship.name,
      type: 'Related to',
      status: relationship.status,
      referenceType: relationship.ciType,
      referenceId: relationship.name,
      reconcilationId: relationship.reconcilationId, // fixed for uat defect CI's & Node CI's in ACE
    },
    toDelete: false,
  };
  unsavedRelationships.push(vineParam);
  return unsavedRelationships;
};

export {
  UPDATE_CRQ_RELATIONSHIPS_REQUEST,
  UPDATE_CRQ_RELATIONSHIPS_SUCCESS,
  UPDATE_CRQ_RELATIONSHIPS_ERROR,
  updateCrqRelationshipsRequest,
  updateCrqRelationshipsSuccess,
  updateCrqRelationshipsError,
  updateCrqRelationships,
  updateVINERelationship,
};
